<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="学校名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入学校名称" />
        </a-form-model-item>
        <a-form-model-item label="省" prop="province">
          <a-input v-model="form.province" placeholder="省" />
        </a-form-model-item>
        <a-form-model-item label="市" prop="city">
          <a-input v-model="form.city" placeholder="市" />
        </a-form-model-item>
        <a-form-model-item label="区" prop="area">
          <a-input v-model="form.area" placeholder="区" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="学校地址" prop="address">
          <a-textarea
            rows="3"
            placeholder="请输入学校地址"
            v-model="form.address"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { SettingSchool } from "@/api";
export default {
  components: {},
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        name: "",
        address: "",
        status: "1",
      },
      form: {},
      statusList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入学校名称!",
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: "省",
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            message: "市",
            trigger: "change",
          },
        ],
        area: [
          {
            required: true,
            message: "区",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入学校地址!",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑学校" : "添加学校";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.status = data.status + "";
        delete this.form.createTime;
        delete this.form.updateTime;
      }
      // 获取数据字典
      this.statusList = await this.common.getSysCodeType("SYS_STATUS");
      console.log(this.statusList);
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          if (this.type == "add") {
            delete newForm.id;
          }
          this.submitSave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 提交
    submitSave(data) {
      this.confirmLoading = true;
      console.log(data);
      SettingSchool.schoolBasicSave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "修改成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
